module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAABWElEQVRoQ+3Y0U3EMAwG4LjNO4zABjBC1apzABvcTQSDtKIbABswAgtUPkXins92nNgVuad7iJP/i3uSrxAO/oGD5w8NYN3B1oHWgcwbaI9Q5gVml/+fDszz/ISIz8uynDnXJq2jnkHqwDAM9zHGnxDCHSK+r+v6SjlAWkfZ+7qGBEiLx3F86bruLX3nIKR1VAQZ4BXBAnhEsAHeECKAJ4QY4AWRBfCAyAZYI1QAlgg1gBVCFWCBUAfURhQB1EQUA6RJtO/7TwB4QMTvfd+Hbdt+bw1p3LoigL8x+iOEkP5DsMLHGFl16oCa4VM3VQG1w6sCLMKrAazCqwAsw2cDrMNnATyEFwO8hBcBPIVnA7yFZwE8hmcBpmn6AoBHzmyTDpDW3Rr6RK8WAeBEnSqvB6RXi5I6dQB1w9rrVIe52uFZvwGLcJQzWwcot1RyTetAydul7H34DlwAtOpOT0e0P/QAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow2right.png
// module id = 2khQ
// module chunks = 1